import React, { useEffect, useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Box,
} from "@chakra-ui/react";

import CurrencyFormat from "react-currency-format";
import { Form, InputGroup } from "react-bootstrap";
import {  CheckCircleOutlined } from "@ant-design/icons";
import { VscRefresh } from "react-icons/vsc";

const AmountPopover = ({addAmount,roundOfAmount}) => {
  const [roundOffAmount, setRoundOffAmount] = useState("")

  useEffect(()=>{
    if(roundOfAmount){
      setRoundOffAmount(roundOfAmount)
    }
  },[roundOfAmount])
  const handleRight = (onClose)=>{
    if(roundOffAmount){
      addAmount(roundOffAmount)
      onClose(); 
    }
  }
  return (
    <Popover placement="top">
      {({ isOpen, onClose }) => (
        <>
          <PopoverTrigger>
            <VscRefresh title="Round Off" size={18}  className="add-amount-btn" />
          </PopoverTrigger>
          <PopoverContent className="amount-popover">
            <PopoverBody>
                <Box display="flex">
                <InputGroup>
                        <InputGroup.Text>
                          <span className="rupee-symbol">₹</span>{" "}
                        </InputGroup.Text>
              <CurrencyFormat
                customInput={Form.Control}
                className="add-amount-input"
                type="text"
                name="roundoff"
                onValueChange={(e) => {
                  setRoundOffAmount(e.value);
                }}
                value={roundOffAmount || ""}
                placeholder="Round Off"
                thousandSeparator={true}
                // prefix={"$"}
                decimalScale={2}
                fixedDecimalScale={true}
              />
                <InputGroup.Text>
                <div className="check-btn" onClick={()=>handleRight(onClose)}>
                  <CheckCircleOutlined 
                    size={14}
                    style={{
                      color: roundOffAmount ? "green" : "gray",
                      cursor: roundOffAmount ? "pointer" : "not-allowed",
                    }}
                  />
                </div>
                </InputGroup.Text>
              </InputGroup>


                </Box>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default AmountPopover;
